import { Card } from '@delmonicos/shared-design-system-react/src/components/card/card';
import { Divider } from '@delmonicos/shared-design-system-react/src/components/divider/divider';
import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { AccentTitle } from '@delmonicos/shared-design-system-react/src/components/typography/title/accent-title/accent-title';
import { HeadingEnum } from '@delmonicos/shared-design-system-react/src/models/enums/heading.enum';
import { formatDate } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/formatters/format-date';
import { TariffModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpi/src/ocpi-cpo-api/models/tariffs/tariff.model';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import i18n from '@app/core/locale/i18n';

interface InformationCardComponentProps {
  tariff: TariffModel;
}

export const InformationCardComponent = ({
  tariff,
}: InformationCardComponentProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  const { t } = useTranslation();

  // TODO: Should be moved in SDK
  const startDate = useMemo(() => {
    const firstElement = tariff.elements[0];
    return firstElement?.restrictions?.start_date;
  }, [tariff]);

  // TODO: Should be moved in SDK
  const endDate = useMemo(() => {
    const firstElement = tariff.elements[0];
    return firstElement?.restrictions?.end_date;
  }, [tariff]);

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <Card gap={GapEnum.M} direction="column">
      <AccentTitle
        icon="info-circle"
        text={t('$.emsp-bo-tariff-details.information.title')}
        as={HeadingEnum.H2}
      />

      <Stack gap={GapEnum.M} justifyContent="space-between">
        <Text bold>
          {t('delmonicos-shared-sdk.ocpi-cpo-api-models-tariff.currency')}
        </Text>
        {tariff.currency}
      </Stack>

      <Divider />

      <Stack gap={GapEnum.M} justifyContent="space-between">
        <Text bold>
          {t('delmonicos-shared-sdk.ocpi-cpo-api-models-tariff.last-updated')}
        </Text>
        {formatDate(tariff.last_updated, i18n)}
      </Stack>

      <Divider />

      <Stack gap={GapEnum.S} direction="column">
        <Text>{t('$.emsp-bo-tariff-details.information.validity.title')}</Text>
        <Stack gap={GapEnum.M} justifyContent="space-between">
          <Stack gap={GapEnum.M} justifyContent="space-between" flex={1}>
            <Text bold>
              {t(
                'delmonicos-shared-sdk.outputs-tariff-restrictions.start-date',
              )}
            </Text>
            {startDate ? formatDate(startDate, i18n) : '-'}
          </Stack>
          <Stack gap={GapEnum.M} justifyContent="space-between" flex={1}>
            <Text bold>
              {t('delmonicos-shared-sdk.outputs-tariff-restrictions.end-date')}
            </Text>
            {endDate ? formatDate(endDate, i18n) : '-'}
          </Stack>
        </Stack>
      </Stack>
    </Card>
  );
};
